export const ENABLE = 'ENABLE'
export const DISABLE = 'DISABLE'
export const ENABLING = 'ENABLING'
export const DISABLE_SCENARIO = 'DISABLE_SCENARIO'
export const ENABLE_SCENARIO = 'ENABLE_SCENARIO'
export const HEADING = 'HEADING'
